import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { alpha, styled } from "@mui/material/styles";
import { useEffect, useRef } from "react";

const SearchField = ({ value, setValue, SearchValue, placeholder, style }) => {
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    let timeout = setTimeout(() => {
      SearchValue();
    }, 1000);

    return () => clearTimeout(timeout);
  }, [value]);
  const defaultStyle = {
    display: "flex",
    marginBottom: "10px",
    justifyContent: "space-between",
  };

  return (
    <div
      style={{ ...defaultStyle, ...(style || {}) }}
    >
      <div></div>

      <div
        id="voucher_list_filter"
        style={{ display: "flex" }}
        className="dataTables_filter"
      >
        {/* <label style={{ marginRight: "10px", fontWeight: "400" }}>
          Search:
        </label> */}
        <input
          type="search"
          value={value}
          onChange={setValue}
          aria-label="search"
          className="form-control form-control-sm"
          placeholder="Search"
          style={{  maxWidth: "188px",...(style || {}) }}
          aria-controls="voucher_list"
        />
      </div>
    </div>
  );
};

export default SearchField;
